(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tcg-live-open"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-live-open-product')) return;
    document.querySelectorAll('input[data-live-open-product]').forEach((other) => {
      if (other.dataset.liveOpenProduct === input.dataset.liveOpenProduct) other.checked = input.checked;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
